import styled from '@emotion/styled'
import {
  AiOutlineClose,
  AiOutlineDown,
  AiOutlineShoppingCart,
  AiOutlineRight,
} from 'react-icons/ai'
import { FcFlashOn } from 'react-icons/fc'
import { useHistory } from 'react-router'
import TitleHeader from '../../../components/app-layout/AppHeader/TitleHeader'
import Breadcrumb from '../../../components/common/Breadcrumb'
import Button from '../../../components/common/Button'
import Image from '../../../components/common/Image'
import Text from '../../../components/common/Text'
import PriceFormatter from '../../../components/PriceFormatter'
import { LIGHT_ORANGE, SHOP_PRIMARY, WHITE } from '../../../constant/colors'
import { productDetailDescription, shop } from '../../../constant/path'
import { useAddProductToCart } from '../../../services/cart/cart-query'
import { useGetProductDetail } from '../../../services/shop/shop-query'
import { useRouter } from '../../../utils/helper'
import { mobile, useScreen } from '../../../utils/responsive-helper'
import AddCartFooter from '../components/AddCartFooter'
import ProductDesciptionCard from '../components/ProductDesciptionCard'

const Layout = styled.div`
  margin-top: 20px;

  ${mobile} {
    margin-top: 0px;
  }
`

const ProductLayout = styled.div`
  display: flex;
  background-color: ${WHITE};
  margin: 16px 0;
  height: 50vw;
  max-height: 520px;

  ${mobile} {
    height: auto;
    max-height: none;
    flex-direction: column;
    margin: 64px 0 8px 0;
  }
`

const ProductImageLayout = styled.div`
  width: 50%;

  ${mobile} {
    width: 100%;
    position: relative;
    margin-bottom: 8px;
    padding-bottom: 100%;
  }
`

const ProductImage = styled(Image)`
  width: 100%;
  height: 100%;
  ${mobile} {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
  }
`

const ProductDetailSection = styled.div``

const ProductDetailStyled = styled.div`
  width: 50%;
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mobile} {
    display: block;
    width: 100%;
  }
`

const ProductNameText = styled(Text)`
  padding-bottom: 24px;

  ${mobile} {
    padding-bottom: 16px;
  }
`

const AddCartSection = styled.div`
  margin-bottom: 24px;

  ${mobile} {
    margin-bottom: 0px;
  }
`

const FlashSaleLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  margin-top: 16px;
  background-color: ${LIGHT_ORANGE};
`

const FlashSaleStyle = styled.div`
  font-size: 22px;
  display: flex;
  align-items: center;
`

const AddCartButtonLayout = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`

const AddCartButtonStyled = styled(Button)`
  display: flex;
  width: 49%;
  border-radius: 100px;
`

const AddCartText = styled.div`
  padding-left: 8px;
  font-size: 16px;
`

const FlashSaleRightIcon = styled.div`
  font-size: 18px;
`

const ProductDescriptionLayout = styled.div`
  background-color: ${WHITE};
  margin: 16px 0;
  padding: 16px;

  ${mobile} {
    margin: 8px 0 98px 0;
  }
`

const MoreInformationText = styled(Text)`
  padding-right: 4px;
`

const ProductDetail = () => {
  const history = useHistory()
  const { productId, page } = useRouter().query
  const { isMobile } = useScreen()
  const { data: productDetail } = useGetProductDetail(productId)
  const { mutate: addProductToCart } = useAddProductToCart()
  const flashsaleData = undefined

  const handleMoreInformationNavigation = () => {
    history.push(
      productDetailDescription({
        routeParam: {
          productId,
        },
      }),
    )
  }

  const handleAddProductInCart = (e: any) => {
    addProductToCart({
      productId,
      quantity: 1,
    })
    e.stopPropagation()
  }

  return (
    <Layout>
      {isMobile ? (
        <TitleHeader title={productDetail?.title || ''} icon={<AiOutlineClose />} path={page} />
      ) : (
        <Breadcrumb
          overide={(paths) => {
            paths[0] = {
              label: 'หน้าสินค้า',
              path: shop(),
            }
            paths[1] = {
              label: 'category',
              path: shop(),
            }
            paths[2] = {
              label: productDetail?.title || '',
              path: shop(),
            }
            return paths
          }}
        />
      )}
      <ProductLayout>
        <ProductImageLayout>
          {productDetail?.thumbnailImage && <ProductImage src={productDetail.thumbnailImage} />}
        </ProductImageLayout>
        <ProductDetailStyled>
          <ProductDetailSection>
            <ProductNameText size={isMobile ? 20 : 24}>{productDetail?.name}</ProductNameText>
            {productDetail?.normalCoin !== 0 && (
              <PriceFormatter
                fontSize={isMobile ? 14 : 20}
                priceType="additional"
                value={productDetail?.normalCoin || 0}
              />
            )}
            <PriceFormatter
              fontSize={isMobile ? 32 : 36}
              lineHeight={isMobile ? 36 : 40}
              priceType="display"
              value={productDetail?.specialCoin || 0}
            />
          </ProductDetailSection>
          <AddCartSection>
            {flashsaleData && (
              <FlashSaleLayout>
                <FlashSaleStyle>
                  <FcFlashOn />
                  <Text size={16} style={{ lineHeight: '22px', paddingLeft: '4px' }}>
                    Flash Sale เริ่มเวลา 18:00, 15 พฤศจิกายน
                  </Text>
                </FlashSaleStyle>
                <FlashSaleRightIcon>
                  <AiOutlineRight />
                </FlashSaleRightIcon>
              </FlashSaleLayout>
            )}
            {!isMobile && (
              <AddCartButtonLayout>
                <AddCartButtonStyled
                  fontColor={SHOP_PRIMARY}
                  style={{
                    background: 'transparent',
                    marginRight: 8,
                    borderColor: SHOP_PRIMARY,
                  }}
                >
                  <AiOutlineShoppingCart /> <AddCartText>เพิ่มไปยังตะกร้าสินค้า</AddCartText>
                </AddCartButtonStyled>
                <AddCartButtonStyled background={SHOP_PRIMARY}>ชื้อเลย</AddCartButtonStyled>
              </AddCartButtonLayout>
            )}
          </AddCartSection>
        </ProductDetailStyled>
      </ProductLayout>
      <ProductDescriptionLayout>
        <ProductDesciptionCard
          description={`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
          been the industry's standard dummy text ever since the 1500s, when an unknown printer took
          a galley of type and scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting, remaining essentially
          unchanged. It was popularised in the 1960s with the release of Letraset sheets containing`}
        />
        <AddCartButtonStyled
          fontColor={SHOP_PRIMARY}
          style={{
            width: '100%',
            maxWidth: '100%',
            background: 'transparent',
            marginRight: 8,
            borderColor: 'transparent',
          }}
        >
          <MoreInformationText
            color={SHOP_PRIMARY}
            type="SemiBold"
            onClick={handleMoreInformationNavigation}
          >
            เพิ่มเติม
          </MoreInformationText>
          <AiOutlineDown />
        </AddCartButtonStyled>
      </ProductDescriptionLayout>
      {isMobile && (
        <AddCartFooter
          content="ราคาสินค้า"
          textButton="เพิ่มลงในตะกร้า"
          value={1234}
          onClick={(e) => handleAddProductInCart(e)}
        />
      )}
    </Layout>
  )
}

export default ProductDetail
